import { forwardRef } from 'react';
import { Box, BoxProps } from './box';

/**
 * FlexCenter component - A convenience wrapper for centered content.
 *
 * Pre-configured with `display="flex"`, `justifyContent="center"`, and `alignItems="center"`.
 * Used in ~12% of Box patterns for centering content (PhotoModal, LoadingScreen, ErrorStates).
 *
 * @example
 * // Loading state
 * <FlexCenter height={200}>
 *   <CircularProgress />
 * </FlexCenter>
 *
 * @example
 * // Empty state
 * <FlexCenter height="100vh" flexDirection="column" gap={2}>
 *   <EmptyIcon />
 *   <Typography>No items found</Typography>
 * </FlexCenter>
 *
 * @example
 * // Modal content
 * <FlexCenter minHeight={400}>
 *   <Card>
 *     <CardContent>Centered Card</CardContent>
 *   </Card>
 * </FlexCenter>
 */
export type FlexCenterProps = BoxProps;

export const FlexCenter = forwardRef<HTMLDivElement, FlexCenterProps>((props, ref) => (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  <Box ref={ref as any} display="flex" justifyContent="center" alignItems="center" {...props} />
));

FlexCenter.displayName = 'FlexCenter';
